import { AnimatedPresenceList } from '@affine/core/components/animated-presence-list';
import { useSidebarSearchState } from '@affine/core/components/sidebar-tree-search';
import type { ReactNode } from 'react';

import { SIDEBAR_ATOM_STEP } from '../../../../modules/app-sidebar/views/sidebar-layout';

export const AnimatedNavigationPanelTreeChildren = ({
  children,
  animateEnteringHeight,
}: {
  children?: ReactNode;
  animateEnteringHeight?: boolean;
}) => {
  const search = useSidebarSearchState();
  return (
    <AnimatedPresenceList
      animate={search.animate}
      animateEnteringHeight={animateEnteringHeight}
      defaultHeight={SIDEBAR_ATOM_STEP}
      itemDataAttribute="data-navigation-panel-tree-presence-item"
    >
      {children}
    </AnimatedPresenceList>
  );
};
